import { PUBLIC_API_URL } from "../config/env";

export interface Insurer {
  code: string;
  title: string;
}

interface InsurersResponse {
  data?: { items?: Insurer[] };
  error?: boolean;
  message?: string;
}

const REQUEST_TIMEOUT = 15000;

let cache: Insurer[] | null = null;
let inFlight: Promise<Insurer[]> | null = null;

/**
 * Список СК приходит из API — захардкоженного перечня в конструкторе быть не должно:
 * состав страховщиков меняется без релиза фронта.
 */
export async function getInsurers(): Promise<Insurer[]> {
  if (cache) return cache;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

    try {
      const response = await fetch(`${PUBLIC_API_URL}/insurers`, {
        method: "GET",
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`Не удалось получить список страховых компаний (${response.status})`);
      }

      const result = (await response.json()) as InsurersResponse;
      if (result.error) {
        throw new Error(result.message || "Не удалось получить список страховых компаний");
      }

      cache = (result.data?.items ?? []).map(({ code, title }) => ({ code, title }));
      return cache;
    } finally {
      clearTimeout(timer);
    }
  })();

  try {
    return await inFlight;
  } finally {
    inFlight = null;
  }
}
